import { teams } from "@/mocks/teams";
import type { Team, Match } from "@/types";

export function getTeam(id: string): Team {
  const found = teams.find((t) => t.id === id);
  return (found as Team) || (teams[0] as Team);
}

export function formatDateCN(date: string): string {
  const d = new Date(`${date}T00:00:00`);
  const week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  return `${d.getMonth() + 1}月${d.getDate()}日 ${week[d.getDay()]}`;
}

export function weekdayCN(date: string): string {
  const d = new Date(`${date}T00:00:00`);
  const week = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  return week[d.getDay()];
}

export const statusMap: Record<Match["status"], { label: string; short: string }> = {
  live: { label: "直播中", short: "LIVE" },
  upcoming: { label: "未开始", short: "即将开始" },
  finished: { label: "已结束", short: "完场" },
};

export function todayStr(): string {
  return "2026-10-09";
}

export function uniqueDates(dates: string[]): string[] {
  return Array.from(new Set(dates)).sort();
}